import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import identityDetails from '../../../../../graphql/fragments/identity/identityDetails';
import albumMembershipGroupPurchaseDetails from '../fragments/albumMembershipGroupPurchaseDetails';
import { PhotoThumbnails } from '../../../../../../consumer/graphql/fragments/global';

export const getAlbumMembershipGroupQuery = gql`
  query getAlbumMembershipGroup($id: RecordID!, $album_folder_id: RecordID) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      display_name
      album_memberships_has_all_photos_access(use_all_photos_mode: true)
      identities {
        identity {
          ...identityDetails
        }
        matched_photos_extended {
          total
        }
        has_purchased_subscription
        is_owner
      }
      entitled_matched_photos(slice: { limit: 1 }) {
        records {
          id
          ...PhotoThumbnails
        }
      }
      matched_photos_extended(slice: { limit: 1 }) {
        total
      }
      is_owner
      ...albumMembershipGroupPurchaseDetails
    }
  }
  ${identityDetails}
  ${albumMembershipGroupPurchaseDetails}
  ${PhotoThumbnails}
`;

const getAlbumMembershipGroupOptions = {
  options: ({ albumMembershipGroupId }) => ({
    variables: {
      id: albumMembershipGroupId,
    },
    fetchPolicy: 'cache-first',
  }),
  skip: ({ albumMembershipGroupId }) => !albumMembershipGroupId,
};

const getAlbumMembershipGroup = graphql(
  getAlbumMembershipGroupQuery,
  getAlbumMembershipGroupOptions,
);

export default getAlbumMembershipGroup;
